export const TICKETS_PANEL_ID = 'tickets-panel'
